import React, { useEffect, useState } from "react";

// Helper to generate the SVG noise background based on theme
const getNoiseSvgUrl = (color) => {
  const svg = `<svg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='10' cy='10' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='30' cy='40' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='70' cy='20' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='50' cy='80' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='80' cy='60' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='20' cy='70' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='60' cy='50' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='15' cy='30' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='40' cy='15' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='85' cy='35' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='75' cy='85' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='55' cy='60' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='35' cy='90' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='90' cy='10' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='5' cy='60' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='25' cy='25' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='45' cy='45' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='65' cy='65' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='85' cy='85' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='95' cy='95' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='55' cy='15' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='75' cy='25' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='35' cy='55' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='15' cy='75' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='95' cy='5' r='0.8' fill='${color}' fill-opacity='0.3'/><circle cx='5' cy='95' r='0.8' fill='${color}' fill-opacity='0.3'/>
  </svg>`;
  return `url("data:image/svg+xml;utf8,${encodeURIComponent(
    svg
  )}") left top repeat`;
};

function getThemeNoiseUrl() {
  if (
    typeof window !== "undefined" &&
    document.documentElement.classList.contains("dark")
  ) {
    return getNoiseSvgUrl("white");
  }
  return getNoiseSvgUrl("black");
}

const UsageStatsCards = ({ stats, title = "Overall Usage Stats" }) => {
  const [noiseUrl, setNoiseUrl] = useState(getThemeNoiseUrl());

  useEffect(() => {
    // Listen for theme changes
    const html = document.documentElement;
    const updateNoise = () => setNoiseUrl(getThemeNoiseUrl());
    updateNoise();
    const observer = new MutationObserver(() => {
      updateNoise();
    });
    observer.observe(html, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="mb-8">
      <h2 className="text-base font-semibold mb-4">{title}</h2>
      <div
        className={`grid grid-cols-1 md:grid-cols-${stats.length} gap-4 w-full`}
      >
        {stats.map((stat, i) => (
          <div
            key={i}
            className="rounded-xl p-4 flex flex-col items-center justify-center min-h-[90px]"
            style={{
              background: `
                ${noiseUrl},
                linear-gradient(110deg, var(${stat.colorVar}) 5%, var(--bg-60) 100%)
              `,
            }}
          >
            <div className="text-xs text-fg-50 mb-1">{stat.label}</div>
            <div
              className="text-2xl font-semibold"
              style={{ color: `var(${stat.fgVar})` }}
            >
              {stat.value}
            </div>
            {stat.unit && (
              <div className="text-xs text-fg-50 mt-1">{stat.unit}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default UsageStatsCards;
